import type { ParentComponent } from "solid-js";
import extendeLogo from "@/assets/extended-light-logo.svg";
import { AuthMatchPanel } from "@/domains/auth/components/match-panel/AuthMatchPanel";

export const AuthLayout: ParentComponent = (props) => {
  return (
    <div class="min-h-screen flex flex-col bg-white h-full">
      {/* Top Bar */}
      <header class="w-full border-b border-gray-200">
        <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div class="flex items-center justify-center h-16">
            <img
              src={extendeLogo}
              alt="Sevedemo logo"
              class="w-auto h-8 block md:hidden"
            />
            <img
              src={extendeLogo}
              alt="Sevedemo logo"
              class="w-auto h-6 hidden md:block"
            />
          </div>
        </div>
      </header>

      {/* Split Layout - Main Content */}
      <main class="flex-1 flex">
        {/* Left Side - Auth Content */}
        <div class="flex-1 flex items-center justify-center lg:p-8 p-4">
          <div class="w-full max-w-xl">{props.children}</div>
        </div>

        {/* Right Side - decorative match visual (desktop only) */}
        <div class="hidden lg:flex flex-1 sticky top-0 h-[calc(100vh-4rem)] shrink-0 items-center justify-center p-8 bg-matisse-50">
          <AuthMatchPanel />
        </div>
      </main>

      {/* The legal links footer now lives in the global in-app footer
          (GlobalFooter, mounted at the router root) — kept here as a single
          source to avoid a duplicated footer on auth pages (A5). */}
    </div>
  );
};
